import { george, observer, React, RouteComponentProps, ui, pr } from "aaa";
import { MyLoginData } from "components/sIdentitySettings/SIdentitySettingsHomeScreen";
import { AliasStore } from "./AliasStore";

type IProps = RouteComponentProps<{}> & {
    store: AliasStore
};

export const AliasOverview = observer(({ store }: IProps) => (
    <george.Background style={{ padding: 16 }}>
        <george.LoadingIndicator isLoading={store.isLoading} height={ui.windowHeight} />
        {!store.isLoading && (
            <>
                {/* <pr.P_32_TITLE style={{ fontWeight: 700, marginBottom: 16 }}>
                    {ui.__("alias.overview.title")}
                </pr.P_32_TITLE> */}
                <MyLoginData hideTitle store={store} />
            </>
        )}
    </george.Background>
));




// WEBPACK FOOTER //
// ./src/components/alias/AliasOverview.tsx